import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BoothService {
  is_display_booth_register_component = false;
  boothUpdate = new EventEmitter<Booth>();

  downloadBooth = new EventEmitter<boolean>();
  private _booth_data: Booth = null;

  constructor() { }

  set set_booth_data(booth) {
    this._booth_data = booth;
  }

  get get_booth_data() {
    return this._booth_data;
  }
}

export interface Booth {
  id: number;
  name: string;
}
